<template>
    <div class="o-Radio__wrapper">
        <label class="o-Form__fields-label o-Form__fields-label--radio" :class="{'o-Form__fields-label--radio-disabled': disable}">
            <input type="radio" :disabled=disable @change="$emit('input',$event.target.value);onchange($event)" @focus="$emit('focus')" v-model="value" :name="name" :value="label" tabindex="0">
            <span class="checkmark"></span>
            <div class="o-Radio__content">
                <slot></slot>
            </div>
        </label>
    </div>
</template>

<script>
export default {
    name: 'radio',    
    props: ['name', 'label', 'disable', 'default'],
    data() {
        return {
            value: null,
            pcfTraining: {
                option: null
            },
        }
    },
    created () {
        if(this.default) this.value = this.default;
    },
    watch: {
        disable () {
            if (this.disable) {
                this.value = null;
            }
        },
        default () {
            if (this.default) {
                this.value = this.default;
            } else {
                this.value = null;
            }
        }
    },
    methods: {
        onchange (e) {
            this.$emit('change', e.target.checked);
        }
    }
}
</script>